import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

export interface AccountAccessRestrictedDialogData {
  accountId?: string;
  contactEmail?: string;
}

@Component({
  selector: 'app-account-access-restricted-dialog',
  standalone: false,
  templateUrl: './account-access-restricted-dialog.component.html',
  styleUrl: './account-access-restricted-dialog.component.scss'
})
export class AccountAccessRestrictedDialogComponent {
  accountId: string = '';
  contactEmail: string = '';

  constructor(
    public dialogRef: MatDialogRef<AccountAccessRestrictedDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: AccountAccessRestrictedDialogData
  ) {
    this.accountId = data?.accountId || '';
    this.contactEmail = data?.contactEmail || 'support@cantrak.io';
  }

  onClose(): void {
    this.dialogRef.close();
  }
}
